import { useEffect, useState } from "react";
import { CheckFormComponent } from "./components/CheckFormComponent/CheckFormComponent";
import { ScannerComponent } from "./components/ScannerComponent/ScannerComponent";
import { useNavigate, useParams } from "react-router-dom";
import { EventOrganizer } from "../../../types/types";
import { checkAuth, getAuthToken } from "../../../utils/utils";
import { API_BASE } from "../../../config/api";

export const ScannerQR = () => {
  const [isScanning, setIsScanning] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [event, setEvent] = useState<EventOrganizer>();
  const url = `${API_BASE}`;
  const { id } = useParams();
  const navigate = useNavigate();
  const idNumber = parseInt(id!, 10);

  if (!checkAuth()) navigate("/registrationPage");
  const token = getAuthToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);

        const data = await fetch(`${url}/events/${id}/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json());

        if (!data || data.length === 0) {
          throw new Error("Событие не найдено");
        }

        setEvent(data);
      } catch (error: any) {
        console.error("Ошибка загрузки данных:", error);
        setError(error.message || "Ошибка при загрузке данных");
      } finally {
      }
    };

    fetchData();
  }, [id, token, url]);

  if (event && (!event.is_owner || event.is_finished || event.is_canceled)) {
    navigate(`/404`);
  }

  useEffect(() => {
    if (error) {
      alert(error);
    }
  }, [error]);

  return (
    <div>
      {isScanning ? (
        <ScannerComponent
          onSwitch={() => setIsScanning(false)}
          id={idNumber}
          eventName={event?.name}
        />
      ) : (
        <CheckFormComponent
          onSwitch={() => setIsScanning(true)}
          id={idNumber}
          eventName={event?.name}
        />
      )}
    </div>
  );
};
